
// Script per il banner promozionale
document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("promo-banner");

  if (!banner) {
    console.warn("Promo banner non trovato.");
    return;
  }

  const clone = banner.cloneNode(true);
  clone.classList.add("fixed");
  document.body.appendChild(clone);

  let lastScroll = 0;
  window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY;

    if (scrollTop > 100 && scrollTop > lastScroll) {
      clone.classList.add("visible");
    } else {
      clone.classList.remove("visible");
    }

    lastScroll = scrollTop;
  });
});

// Script per il popup della newsletter
document.addEventListener('DOMContentLoaded', function () {
  const apri1 = document.getElementById('apri-popup-newsletter');
  const apri2 = document.getElementById('apri-popup-top');
  const popup = document.getElementById('popup-newsletter');
  const chiudi = document.getElementById('chiudi-popup');

  if (popup && chiudi) {
    [apri1, apri2].forEach(function (btn) {
      if (btn) {
        btn.addEventListener('click', function () {
          popup.style.display = 'flex';
        });
      }
    });

    chiudi.addEventListener('click', function () {
      popup.style.display = 'none';
    });
  }
});
